import $ from 'jquery';

export default class StDropDown {
  init(){
    if(!sttheme.is_mobile_device)
    {
        $('body').on({
            mouseenter: function () {
                $(this).addClass('open').trigger($.Event('st.dropdown.shown', this));
            },
            mouseleave: function () {
                $(this).removeClass('open');
            }
        }, ".dropdown_wrap");
    }else{
        $('body').on(
      'touchstart',
      '.dropdown_tri',
      function(event){
        let dropdown_wrap = $(this).closest('.dropdown_wrap');
        if(!dropdown_wrap.hasClass('open'))
        {
            event.preventDefault();
            dropdown_wrap.addClass('open').trigger($.Event('st.dropdown.shown', dropdown_wrap[0]));
            return false;
        }
        if($(this).attr('href') && $(this).attr('href')!='javascript:;')
            return true;
        dropdown_wrap.removeClass('open')
        return false;
      });
    }

  }
}



// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js